export const css = {
	icon: '_4h37s8L3',
	clockIcon: '_2K869Mpc',
	eyeIcon: '_1I6kst_j',
	eyeSlashIcon: '_2jsTHsC2',
	plusIcon: '_3GQmuOAG',
	minusIcon: '_1nciVuBs',
	checkIcon: '_1wgpuhm9',
	closeIcon: '_34zXzoXZ',
	leftIcon: '_1-9CYpF_',
	rightIcon: '_2_rnKsiI',
	upIcon: '_1Wv4vKym',
	downIcon: '_3OnYCv6p',
	upAltIcon: '_1nz0cC6O',
	downAltIcon: '_2bS1eqKG',
	searchIcon: '_3ErNBDoU',
	barsIcon: '_36AoS9OG',
	settingsIcon: '_2EXtpKhQ',
	alertIcon: '_3XVEqxjP',
	helpIcon: 'pcHQydYQ',
	infoIcon: '_2pS3QEMQ',
	cancelIcon: '_2LVh5zl0',
	checkedBoxIcon: '_2a79KgGT',
	phoneIcon: '_1Djv7AoP',
	editIcon: 'w9jOmMIV',
	dateIcon: '_2mn3vh7g',
	linkIcon: '_1eMctrcI',
	locationIcon: '_2eK32Pmw',
	secureIcon: 'MK_WmUoB',
	mailIcon: '_2jsEi8uv',
	starIcon: '_71ADhIOJ',
	' _key': 'certwise-theme/certwise/dojo/icon'
};

export default css;
